module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "encyclopedia"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.$t('categories.encyclopedia'),
      "level": 2,
      "font": "astonished",
      "color": "red"
    }
  }), _vm._v(" "), _c('nav', [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'styles'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "hashtag",
      "scale": "1.3"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('encyclopedia.styles')) + "\n    ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'bands'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "group",
      "scale": "1.3"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('encyclopedia.bands')) + "\n    ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'artists'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "address-book-o",
      "scale": "1.3"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('encyclopedia.artists')) + "\n    ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'albums'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "music",
      "scale": "1.3"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('encyclopedia.albums')) + "\n    ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'audios'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-audio-o",
      "scale": "1.3"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('encyclopedia.audios')) + "\n    ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'videos'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "video-camera",
      "scale": "1.3"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('encyclopedia.videos')) + "\n    ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'labels'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "tag",
      "scale": "1.3"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('encyclopedia.labels')) + "\n    ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'places'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "map-marker",
      "scale": "1.3"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('encyclopedia.places')) + "\n    ")], 1)], 1), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('encyclopedia.stats')))]), _vm._v(" "), _c('div', {
    staticClass: "figures"
  }, [(_vm.stats.length > 0) ? _c('ul', [_c('li', [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.$n(_vm.stats[7].value, 'decimal')))]), _vm._v("\n        " + _vm._s(_vm._f("lowercase")(_vm.$t('encyclopedia.styles'))) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.$n(_vm.stats[0].value, 'decimal')))]), _vm._v("\n        " + _vm._s(_vm._f("lowercase")(_vm.$t('encyclopedia.bands'))) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.$n(_vm.stats[5].value, 'decimal')))]), _vm._v("\n        " + _vm._s(_vm._f("lowercase")(_vm.$t('encyclopedia.artists'))) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.$n(_vm.stats[1].value, 'decimal')))]), _vm._v("\n        " + _vm._s(_vm._f("lowercase")(_vm.$t('encyclopedia.albums'))) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.$n(_vm.stats[8].value, 'decimal')))]), _vm._v("\n        " + _vm._s(_vm._f("lowercase")(_vm.$t('encyclopedia.audios'))) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.$n(_vm.stats[3].value, 'decimal')))]), _vm._v("\n        " + _vm._s(_vm._f("lowercase")(_vm.$t('encyclopedia.videos'))) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.$n(_vm.stats[2].value, 'decimal')))]), _vm._v("\n        " + _vm._s(_vm._f("lowercase")(_vm.$t('encyclopedia.labels'))) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.$n(_vm.stats[6].value, 'decimal')))]), _vm._v("\n        " + _vm._s(_vm._f("lowercase")(_vm.$t('encyclopedia.places'))) + "\n      ")])]) : _vm._e()]), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2185f80e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/Encyclopedia.vue
// module id = 249
// module chunks = 0